import { BasicEvent } from "~app/features/planera/events/BasicEvent";

export class KundorderCreatedMessage extends BasicEvent {
    kundorderId?: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "KundorderCreatedMessage";
    constructor() {
        super(KundorderCreatedMessage.$type);
    }
}
